<page-data-manager>
  <div class="flash-message-container">
    <flash-message></flash-message>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <div class="page-header">
        <h2>Talhão</h2>
      </div>
    </div>

    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-12">
          <p><strong>Descrição:</strong> {{::gleba.descricao | capitalize}}</p>
          <p>
            <strong>Tamanho do KML:</strong> {{gleba.kml_size / 1024 | number:2}} kb
            <a ng-if="gleba.kml_size > 0 && permissions.glebas.canManage" ng-click="simplify($event, gleba)" href="#">Reduzir tamanho do KML</a>
          </p>
          <p><strong>Área:</strong> {{::gleba.area_total | number:2}} ha</p>
        </div>
      </div>
      <ng-include src="'views/glebas/_mapa.html'"></ng-include>
      <div class="row pull-right padding-top-10" ng-include="'views/glebas/_show_buttons.html'"></div>
    </div>
  </div>
</page-data-manager>
